<template>
  <div class="starter-page finder-page"
    :data-frame="frame">
    <div class="intro">
      <!-- Subtitle -->
      <img src="/static/logo.svg" alt="" class="logo"  height="17" width="143">
      <h3 class="subtitle">
        Skin Solutions
      </h3>
      <!-- Title -->
      <h2 class="title">
        Meet Your Match
        <span class="drop-shadow">
          Meet Your Match
        </span>
      </h2>
      <!-- Details -->
      <p>Tell us about you to reveal your perfect serum</p>
    </div>

    <!-- Girl Animation -->
    <div class="animation-container">
      <div class="frame girl">
        <div class="frame-content">
          <!-- <img :src="currentCharacter" alt=""> -->
          <div v-for="character in characters">
            <img v-show="currentCharacter == character" :src="character"></img>
          </div>

        </div>
      </div>
      <div class="frame product">
        <div class="frame-content">
          <div v-for="product in products">
            <img v-show="currentProduct == product" :src="product"></img>
          </div>
          <!-- <img :src="currentProduct" alt=""> -->
        </div>
      </div>
    </div>
    <!-- CTA -->
    <a class="start-button" @click="startQuiz">
      Find My Match
    </a>
    <!-- Instagram/Twitter Hashtag -->
    <h3 class="subtitle lower">#SerumSOS</h3>
  </div>
</template>

<script>
import anime from 'animejs'
  export default {
    name: "StarterPage",
    props: {
      frame: {
        type: String,
        required: true
      },
    },
    destroyed(){
      //console.log("I've been destroyed!!!!!")
      this.timeline.pause()
    },
    mounted() {
      let self = this;
      let characters = this.characters;
      let products = this.products;

      self.currentCharacter = self.getRandom(characters)
      self.currentProduct = self.getRandom(products)

      let loopCompleted = 0
      let loopBegan = 0;

      // Get Random Product & Character
      this.timeline = anime.timeline({
        autoplay: false,
        loop: false,
        complete: function(anim) {
          characters.push(characters.splice(characters.indexOf(self.currentCharacter), 1)[0]);
          products.push(products.splice(products.indexOf(self.currentProduct), 1)[0]);

          self.currentCharacter = self.getRandom(characters);
          self.currentProduct = self.getRandom(products);

          // console.log('Character is ' + self.currentCharacter)
          // console.log('Product is ' + self.currentProduct)
          // console.log("----------------------------")

          anim.restart();
        }
      });
      // Emoji In
      this.timeline.add({
        targets: '[data-frame="' + self.frame + '"] .frame.girl',
        left: ["-50%", "50%"],
        delay: 400,
        duration: 500,
        easing: "easeOutQuart",
      })
      // Product In
      .add({
        targets: '[data-frame="' + self.frame + '"] .frame.product',
        right: ["-50%", "50%"],
        delay: 0,
        duration: 500,
        offset: "-=500",
        easing: "easeOutQuart",
      })
      // Fadeout
      .add({
        targets: '[data-frame="' + self.frame + '"] .animation-container',
        opacity: [1, 0],
        delay: 1000,
        easing: "easeOutQuart",
        duration: 1000
      });

      this.timeline.play()
    },
    data() {
      return {
        timeline: null,
        characters: [
          "/static/girl1.png",
          "/static/girl2.png",
          "/static/girl3.png",
          "/static/girl4.png"
        ],
        products: [
          "/static/calque.png",
          "/static/hydra-essential.png",
          "/static/mission-perfection.png",
          "/static/double-serum-cap.png",
        ],

        currentProduct: null,
        currentCharacter: null,

      }
    },
    methods: {
      startQuiz() {
        this.$emit('reset');
        this.$router.push("/0/none");
      },
      getRandom(arr) {
        // console.log(arr)
        // let next = arr[(Math.floor(Math.random() * Math.floor(4)))]
        // if(next && next != this.last.character && next != this.last.product){
        //   console.log('%c✔' + next, 'color: green')
        //   return next
        // }else{
        //   this.getRandom(arr)
        // }
        return arr[(Math.floor(Math.random() * Math.floor(3)))];
      }
    }
  }
</script>

<style lang="scss">
  .logo{
    width: 143px;
    height: 17px;
  }

  h3.subtitle {
    font-size: 1rem;
    text-transform: uppercase;
    margin: 0;
    margin-bottom: 5px;

    color: white;

    &.lower{
      text-transform: none;
      margin-bottom: 2.2em;
    }
  }
  .starter-page {
    overflow-x: hidden;
    overflow-y: auto;

    background: linear-gradient(
      90deg,
      #91cbb7,
      #91cbb7 25%,
        #2baade 25%,
      #2baade 50%,
      #f69783 50%,
      #f69783 75%,
      #fbb161 75%,
      #fbb161 100%);

    color: white;

    display: flex;
    flex-direction: column;

    .intro{
      // margin: 40px 0 2rem 0;
     margin: 10px 0 0 0;
     @media all and (min-width: 375px) {
       margin: 40px 0 0 0;
     }
    }

    h2.title {
      font-family: $font-title;
      font-size: 2.6em;
      @media all and (min-width: 375px) {
        font-size: 3em;
      }
      color:white;
      margin: -.15em 0;
      font-weight: normal;

      position: relative;

      .drop-shadow {
        position: absolute;
        left: 50%;
        top: 0%;
        transform: translateX(-50%);

        width: 100%;
        font-weight: normal;

        font-family: $font-title-drop;
        color: white;
      }
    }
    p {
      font-weight: 600;
      margin-top: 0;
      font-size: 0.8rem;
      @media all and (min-width: 375px) {
        font-size: 0.9rem;
      }
    }

    .animation-container {
      position: relative;
      flex-grow: 1;
    }

    .frame {
      width: 55%;
      max-width: 300px;
      margin: auto;
      border: 2px solid $color-primary;
        border-radius: 50%;

        background-color: white;

      .frame-content {
        padding-top: 100%;

      }

      position: absolute;

      img {
        position: absolute;
        width: 100%;
        height: 100%;

        left: 0;
        top: 0;

        object-fit: contain;
      }
    }

    .frame.girl {
      left: -50%;
      top: 50%;
      transform: translate(-85%, -50%);
      z-index: 2;
      margin-left: -5px;
    }

    .frame.product{
      right: -50%;
      top: 50%;
      transform: translate(85%, -50%) ;
      margin-right: -5px;

      img{
        height: 80%;
        width: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) ;

      }
    }
  }

  a.start-button {
    cursor: pointer;
    display: block;
    background-color: #fff;
    color: black;

    // padding: 1.5em 2em;
    width: 200px;
    height: 50px;
    line-height: 50px;

    text-transform: uppercase;

    font-family: $sans-serif;
    font-weight: bold;

    //width: fit-content;
    margin: auto;
    margin-bottom: 1.5em;
    font-size: 13px;
  }
</style>